import { ErrorObject } from '../StoreConstants';

export interface UiInitialState {
    menuState?: boolean;
}

export default {
    menuState: false,
} as UiInitialState;